import React from "react";
import AuthExperience from "../../experience/AuthExperience";
import { beginIdentityLogin } from "../../identity/identityClient";

export default function Login() {
  return (
    <AuthExperience
      onContinue={beginIdentityLogin}
      mode="login"
      productName="My Clikkle"
      productHomeUrl="https://clikkle.com"
      productBrandPath="/images/clikkle/brand/logos/myaccount-logo.png"
    />
  );
}
